import { NavigationSubItem } from "../navigation-item"

export class DesignUiSystemSubItem extends NavigationSubItem {
  readonly id = "design-ui-system"
  readonly label = "UI System"
  readonly href = "/design/ui-system"
  readonly iconName = "design-ui-system-icon"
  readonly isExternal = false
  readonly tabs = []
}
